export const AUTH_SESSION_EPOCH_KEY = "eops:authSessionEpoch";

export const readAuthSessionEpoch = () => {
  try {
    return sessionStorage.getItem(AUTH_SESSION_EPOCH_KEY) || "0";
  } catch {
    return "0";
  }
};

export const bumpAuthSessionEpoch = () => {
  try {
    const next = String(Date.now());
    sessionStorage.setItem(AUTH_SESSION_EPOCH_KEY, next);
    if (typeof window !== "undefined") {
      window.__eopsAuthSessionEpoch = next;
    }
    return next;
  } catch {
    return "0";
  }
};

export const syncAuthSessionEpochToWindow = () => {
  if (typeof window === "undefined") return;
  window.__eopsAuthSessionEpoch = readAuthSessionEpoch();
};

export const isStaleBackForwardCachePage = () => {
  if (typeof window === "undefined") return false;
  const live = readAuthSessionEpoch();
  const frozen = window.__eopsAuthSessionEpoch || "0";
  return live !== frozen;
};
